import { ContractService, updateMcContract } from '@/services/contract.service'
import { SalesManagerService } from '@/services/sales-manager.service'
import { mapGetters } from 'vuex'
import { CommonService } from '@/services/common.service'
import SelectEmployee from '@/components/SelectEmployee.vue'
import ContractAction from './component/ContractAction.vue'
import Header from './component/Header.vue'
import Config from '../../thirdParty/config'
import McInfo from './component/McInfo.vue'
import ContractInfo from './component/ContractInfo.vue'
import CusInfo from './component/CusInfo.vue'
import BankInfo from './component/BankInfo.vue'
import ReceiptInfo from './component/ReceiptInfo.vue'
import PaymentAcceptancePoint from './component/PaymentAcceptancePoint.vue'
import SupportContactInfos from './component/SupportContactInfos.vue'
import SignHistory from './component/SignHistory.vue'
import AppendixDevice from './component/appendix/AppendixDevice.vue'
import AppendixRecall from './component/appendix/AppendixRecall.vue'
import AppendixHandover from './component/appendix/AppendixHandover.vue'
import AppendixLend from './component/appendix/AppendixLend.vue'
import AppendixRent from './component/appendix/AppendixRent.vue'
import AppendixCashback from './component/appendix/AppendixCashback.vue'
import AppendixMultiFunctional from './component/appendix/AppendixMultiFunctional.vue'
import AppendixMoto from './component/appendix/AppendixMoto.vue'
import AppendixUQNH from './component/appendix/AppendixUQNH.vue'
import AppendixVISA from './component/appendix/AppendixVISA.vue'
import AppendixUQKHD from './component/appendix/AppendixUQKHD.vue'
import AppendixLiquid from './component/appendix/AppendixLiquid.vue'
import AppendixTransfer from './component/appendix/AppendixTransfer.vue'
import AppendixWarranties from './component/appendix/AppendixWarranties.vue'
import AppendixQR from './component/appendix/AppendixQR.vue'
import AppendixPackage from './component/appendix/AppendixPackage.vue'
import AppendixFeeTrans from './component/appendix/AppendixFeeTrans.vue'
import AppendixCredit from './component/appendix/AppendixCredit.vue'
import AppendixOnUs from './component/appendix/AppendixOnUs.vue'
import AppendixHomePayLater from './component/appendix/AppendixHomePayLater.vue'
import AppendixAppendixQrConnectors from './component/appendix/AppendixAppendixQrConnectors.vue'
import AppendixChange from './component/appendix/AppendixChange.vue'
import UploadMultiple from '@/components/UploadMultiple.vue'
import formAppendixVisa from './component/form/formAppendixVisa.vue'
import PopupApproveContract from './component/PopupApproveContract.vue'
import AppendixLinkCard from './component/appendix/AppendixLinkCard.vue'
import { DeviceService } from '@/services/device.service'
import ReserveContractModal from './component/ReserveContractModal.vue'

export default {
  components: {
    ReserveContractModal,
    PopupApproveContract,
    SelectEmployee,
    Header,
    ContractAction,
    McInfo,
    ContractInfo,
    CusInfo,
    BankInfo,
    ReceiptInfo,
    PaymentAcceptancePoint,
    SignHistory,
    AppendixDevice,
    AppendixRecall,
    AppendixHandover,
    AppendixLend,
    AppendixRent,
    AppendixCashback,
    AppendixMoto,
    AppendixUQNH,
    AppendixVISA,
    AppendixUQKHD,
    AppendixLiquid,
    AppendixTransfer,
    AppendixPackage,
    AppendixQR,
    AppendixFeeTrans,
    AppendixCredit,
    UploadMultiple,
    AppendixWarranties,
    AppendixMultiFunctional,
    AppendixOnUs,
    AppendixHomePayLater,
    AppendixChange,
    SupportContactInfos,
    AppendixLinkCard,
    AppendixAppendixQrConnectors,
  },
  data() {
    return {
      Config,
      actCode: Config.actionContract,
      cfgPolicyContract: [],
    }
  },
  computed: {
    appendixLiquidId() {
      const appendix =
        this.dataContract.lstAppendixLiquidDates ?? this.dataContract.appendixLiquidDates ?? []
      return appendix.find(s => s.state === 'LIQUIDATE')?.appendixId
    },
    customerInfo() {
      return this.dataContract.customerInfoRes ?? this.dataContract.customerInfoCommon ?? {}
    },
    defaultContractAction() {
      const {
        state,
        stateCollaborator,
        id: contractId,
        groupService,
        typeCustomer,
        customerInfoCommon,
        customerId,
        isPolicyContract,
        customerInfoRes,
      } = this.dataContract
      const typeSale = this.dataUser.typeSale
      return [
        {
          code: this.actCode.OTP,
          text: 'OTP',
          variant: 'warning',
          condition: this.canAccessMx('CNPS_SCON_RESEND_OTP', 'CNPS_SCON_GET_OTP'),
          childrens: [
            {
              code: this.actCode.SEND_OTP,
              text: 'Gửi lại OTP qua SMS',
              condition: this.canAccessMx('CNPS_SCON_RESEND_OTP'),
              action: () => this.resendOTP('RESEND_OTP', contractId),
            },
            {
              code: this.actCode.SEND_OTP,
              text: 'Gửi lại OTP qua Zalo',
              condition: this.canAccessMx('CNPS_SCON_RESEND_OTP'),
              action: () => this.resendOTP('RESEND_OTP', contractId, true),
            },
            {
              code: this.actCode.GET_OTP,
              text: 'Nội dung OTP',
              condition: this.canAccessMx('CNPS_SCON_GET_OTP'),
              action: () => this.resendOTP('GET_CONTENT', contractId),
            },
          ],
        },
        {
          code: this.actCode.APPROVE_UPDATE_CUS,
          text: 'Duyệt chỉnh sửa HĐ',
          variant: 'success',
          condition:
            state === 'WAITING_APPROVED_MA' && this.canAccessMx('CNPS_SCON_APPROVE_UPDATE_CUS'),
          action: this.updateReqCheck,
        },
        {
          code: this.actCode.REQUEST_ADDITIONAL,
          text: 'Cần bổ sung',
          variant: 'primary',
          condition:
            state === 'SIGNED_WAITING_APPROVED' &&
            // ['SALE_DIRECTOR','SALE_ADMIN'].includes(typeSale) &&
            // this.canAccessMx('CNPS_SCON_REQUEST_ADDITIONAL_IMAGE'),
            (this.canAccessMx('CNPS_SCON_REQUEST_ADDITIONAL_IMAGE') ||
              this.canAccessMx('CNPS_SCON_APPROVE_TINGBOX_CONTRACT')),
          action: this.additional,
        },
        {
          code: this.actCode.APPROVE_COLLARBORATOR,
          text: 'GS duyệt',
          variant: 'success',
          condition: state === 'EXPERTISE_COLLABORATOR' && stateCollaborator === 'WAITING',
          action: this.approveCollaborator,
        },
        {
          code: this.actCode.REJECT_COLLARBORATOR,
          text: 'GS từ chối',
          variant: 'danger',
          condition: state === 'EXPERTISE_COLLABORATOR' && stateCollaborator === 'WAITING',
          action: this.rejectCollaborator,
        },
        {
          code: this.actCode.APPROVE_REJECT_FEE,
          text: 'Duyệt phí',
          variant: 'success',
          condition:
            state === 'WAITING_APPROVED_FEE' &&
            ['SALE_DIRECTOR', 'REGION_DIRECTOR'].includes(typeSale) &&
            (typeof isPolicyContract === 'undefined' || !isPolicyContract) &&
            this.canAccessMx('CNPS_SCON_MA_APPROVED_FEE'),
          action: this.approveFee,
        },
        {
          code: this.actCode.APPROVE_REJECT_FEE,
          text: 'Từ chối duyệt phí',
          variant: 'danger',
          condition:
            state === 'WAITING_APPROVED_FEE' &&
            ['SALE_DIRECTOR', 'REGION_DIRECTOR'].includes(typeSale) &&
            (typeof isPolicyContract === 'undefined' || !isPolicyContract) &&
            this.canAccessMx('CNPS_SCON_MA_APPROVED_FEE'),
          action: this.rejectFee,
        },
        {
          code: this.actCode.APPROVE_REJECT,
          text: 'Duyệt',
          variant: 'success',
          condition:
            state === 'SIGNED_WAITING_APPROVED' &&
            // this.canAccessMx('CNPS_SCON_APPROVED_CONTRACT'),
            (this.canAccessMx('CNPS_SCON_APPROVED_CONTRACT') ||
              this.canAccessMx('CNPS_SCON_APPROVE_TINGBOX_CONTRACT')),
          action: this.approve,
        },
        {
          code: this.actCode.APPROVE_REJECT,
          text: 'Từ chối',
          variant: 'danger',
          condition:
            state === 'SIGNED_WAITING_APPROVED' &&
            // this.canAccessMx('CNPS_SCON_REJECT_CONTRACT'),
            (this.canAccessMx('CNPS_SCON_REJECT_CONTRACT') ||
              this.canAccessMx('CNPS_SCON_APPROVE_TINGBOX_CONTRACT')),
          action: this.reject,
        },
        {
          code: this.actCode.MPOS_REJECT,
          text: 'MPOS từ chối',
          variant: 'danger',
          condition:
            ['APPROVED', 'PENDING_APPROVAL', 'PENDING_CONFIRM_APPROVAL'].includes(state) &&
            ['SALE_DIRECTOR', 'SALE_ADMIN'].includes(typeSale) &&
            this.canAccessMx('CNPS_SCON_MOVE_REJECT_WHEN_MPOS_DENY'),
          action: this.rejectMpos,
        },
        {
          code: this.actCode.APPROVE_REJECT_LIQUID,
          text: 'SA từ chối thanh lý',
          variant: 'danger',
          condition:
            state === 'LIQUIDATE' &&
            ['SALE_ADMIN', 'SALE_DIRECTOR'].includes(typeSale) &&
            this.canAccessMx('CNPS_SCON_SA_APPROVED_APPENDIX'),
          action: () => this.rejectAppendix(this.appendixLiquidId),
        },
        {
          code: this.actCode.WAITING_APPROVE,
          text: 'Chuyển Chờ duyệt',
          variant: 'warning',
          condition:
            [
              'APPROVED',
              'EXPERTISE_COLLABORATOR',
              'PENDING_APPROVAL',
              'PENDING_CONFIRM_APPROVAL',
            ].includes(state) && this.canAccessMx('CNPS_SCON_ROLLBACK_SIGNED_WAITING_APPROVED'),
          action: this.changeContractState,
        },
        {
          code: this.actCode.UPDATE_MERCHANT_KEY_TO_NORMAL,
          text: `Chuyển về MC thường`,
          variant: 'warning',
          condition: this.canUpdateMerchantKeyToNormal(state, customerInfoCommon, customerInfoRes),
          action: () => this.updateMerchantKeyToNormal(customerId),
        },
        {
          code: this.actCode.UPDATE_MERCHANT_KEY_TO_MCKEY,
          text: `Chuyển thành MC key`,
          variant: 'warning',
          condition:
            this.canAccessMx('CNPS_CSTM_MERCHANT_KEY_UPDATE_2_MASS') &&
            (customerInfoCommon?.mcLvl == 'MC_NORMAL' || customerInfoRes?.mcLvl == 'MC_NORMAL'),
          action: () => this.updateMerchantKeyToMcKey(customerId),
        },
        {
          code: this.actCode.RE_CREATE_RECEIPT,
          text: 'Sinh lại phiếu thu',
          variant: 'primary',
          condition: this.canReCreateReceipt(state),
          action: this.reCreate,
        },
        {
          code: this.actCode.SYNC_MPOS,
          text: 'Đồng bộ trạng thái HĐ MPOS',
          variant: 'primary',
          condition:
            ['APPROVED', 'PENDING_CONFIRM_APPROVAL'].includes(state) &&
            this.canAccessMx('CNPS_CSTM_CHECK_DETAIL_MPOS_MC'),
          action: this.stateSyncMpos,
        },
        {
          code: this.actCode.SEND_EMAIL,
          text: 'Gửi lại email',
          variant: 'primary',
          condition: state === 'SENT' && this.canAccessMx('CNPS_SCON_RESEND_EMAIL'),
          action: this.resendEmail,
        },
        {
          code: this.actCode.EXPERTISE,
          text: 'Gửi thẩm định',
          variant: 'info',
          condition:
            ['NEW', 'APPROVED_FEE'].includes(state) &&
            ['SALE_ADMIN', 'SALE_DIRECTOR'].includes(typeSale),
          action: this.expertisePaperContract,
        },
        {
          code: this.actCode.ASSIGN_SALE,
          text: 'Gán sale mới',
          variant: 'primary',
          condition: this.canAccessMx('CNPS_SCON_ASSIGN_SALE_AGAIN'),
          action: () => this.$bvModal.show('select-sale-dialog'),
        },
        {
          code: this.actCode.REMOVE_DEVICE,
          text: 'Gỡ thiết bị',
          variant: 'danger',
          condition:
            this.canAccessMx('CNPS_SCON_SA_APPROVED_APPENDIX') &&
            (state === 'REJECTED_SA' || state === 'LIQUIDATE'),
          action: () => this.removeDevice('CONTRACT', contractId),
        },
        {
          code: this.actCode.CREATE_APPENDIX_VISA,
          text: 'Thêm PL KM Phí VISA',
          variant: 'primary',
          condition:
            ['CNPS_SCON_CREATE_VISA_APPENDIX'].includes(state) && groupService === 'PAYMENT',
          action: () => {
            this.showModalComponentMx('Phụ lục VISA', {
              name: formAppendixVisa,
              props: {
                items: [],
                contractId,
              },
              id: 'formAppendixVisa',
              footerClass: 'd-none',
            }).then(_ => this.getDetailContract())
          },
        },
        {
          code: this.actCode.ON_VINVOICE,
          text: `Bật nhận hóa đơn tự động`,
          variant: 'primary',
          condition: this.canOnVinvoice(
            typeCustomer,
            groupService,
            customerInfoRes,
            customerInfoCommon
          ),
          action: () => this.onVinvoice(customerId),
        },
        {
          code: this.actCode.OFF_VINVOICE,
          text: 'Tắt nhận hóa đơn tự động',
          variant: 'primary',
          condition: this.canOffVinvoice(
            typeCustomer,
            groupService,
            customerInfoRes,
            customerInfoCommon
          ),
          action: () => this.offVinvoice(customerId),
        },
        {
          code: this.actCode.APPROVED_POLICY_CONTRACT,
          text: 'Duyệt ND hợp đồng',
          variant: 'primary',
          condition:
            this.canAccessMx('CNPS_SCON_MA_APPROVED_POLICY_CONTRACT') &&
            state === 'WAITING_APPROVED_FEE' &&
            isPolicyContract === true,
          action: () => this.confirmPolicyEcontract(contractId, true),
        },
        {
          code: this.actCode.REJECT_POLICY_CONTRACT,
          text: 'Từ chối ND hợp đồng',
          variant: 'danger',
          condition:
            this.canAccessMx('CNPS_SCON_MA_APPROVED_POLICY_CONTRACT') &&
            state === 'WAITING_APPROVED_FEE' &&
            isPolicyContract === true,
          action: () => this.confirmPolicyEcontract(contractId, false),
        },
        {
          code: this.actCode.HAVE_DKKD,
          text: 'Có/Không DKKD',
          variant: 'primary',
          condition:
            ['APPROVED', 'ACTIVE', 'PENDING_CONFIRM_APPROVAL'].includes(state) &&
            typeCustomer === 'INDIVIDUAL',
          action: () => this.handleOpenDKKD(contractId),
        },
        {
          code: this.actCode.MC_OLD_NEW,
          text: 'MC mới/cũ (TPV)',
          variant: 'primary',
          condition:
            ['APPROVED', 'ACTIVE', 'PENDING_CONFIRM_APPROVAL', 'EXPERTISE'].includes(state) &&
            (this.canAccessMx('CNPS_SCON_OTP_TINGBOX_CONTRACT') ||
              this.canAccessMx('CNPS_SCON_APPROVED_CONTRACT')),
          action: () => this.handleOpenTPV(contractId),
        },
        {
          code: this.actCode.WAITING_APPROVE_TWO,
          text: 'Chuyển về đã duyệt',
          variant: 'primary',
          condition: ['ACTIVE'].includes(state),
          action: () => this.changeApproveTwo(contractId),
        },
        {
          code: this.actCode.WAITING_APPROVE_TWO,
          text: 'Chuyển về đã duyệt(2)',
          variant: 'primary',
          condition: this.canAccessMx('CNPS_SCON_REJECT_CONTRACT') && ['ACTIVE'].includes(state),
          action: () => this.changeApproveTwoS2(contractId),
        },
        {
          code: this.actCode.MPOS_REJECT,
          text: 'Cho phép ký lại',
          variant: 'primary',
          condition: ['REJECTED_SA'].includes(state) && this.canAccessMx('CNPS_SCON_RE_SIGN'),
          action: () => this.changeApproveRejectMpos(contractId),
        },
        {
          code: this.actCode.RESERVE_CONTRACT,
          text: 'Đánh dấu bảo lưu CKS & HDDT',
          variant: 'primary',
          condition: state === 'APPROVED' && this.canAccessMx('CNPS_SCON_RESERVE_CONTRACT'),
          // condition: true,
          action: () => this.showReserveContractModal(),
        },
      ]
    },
    ...mapGetters({
      dataConfigService: 'common/dataConfigService',
    }),
  },
  watch: {},
  methods: {
    showReserveContractModal() {
      this.$refs.reserveContractModal?.show()
    },
    async handleReserveContract(params) {
      try {
        this.showLoading = true
        const response = await ContractService.reserveContract(params)

        if (response.code === 1000) {
          this.getDetailContract()
          this.showSuccessMx(response.message || 'Cập nhật trạng thái bảo lưu thành công')
        } else {
          this.showFailMx(response.message ?? response.error)
        }
      } catch (error) {
        this.showFailMx(error.message || 'Có lỗi xảy ra')
      } finally {
        this.showLoading = false
      }
    },
    defaultAppendixAction(appendix) {
      const {
        state: appendixState,
        isCreatedWithContract,
        appendixId,
        typeAppendix,
        appraisalStatus,
        signType,
      } = appendix
      const {
        state: contractState,
        stateCollaborator,
        id: contractId,
        formContract,
        typeCustomer,
      } = this.dataContract
      const appendixChange = appendix && appendix.appendixChange ? appendix.appendixChange : null
      const appendixRent = appendix && appendix.appendixRent ? appendix.appendixRent : null
      const appendixLend = appendix && appendix.appendixLend ? appendix.appendixLend : null
      const appendixHomePayLater =
        appendix && appendix.appendixHomePayLater ? appendix.appendixHomePayLater : null
      const appendixQrConnector =
        appendix && appendix.appendixQrConnector ? appendix.appendixQrConnector : null

      const appendixLinkCard =
        appendix && appendix.appendixLinkCard ? appendix.appendixLinkCard : null
      const typeSale = this.dataUser.typeSale
      const isGenPDF =
        formContract === 'E_CONTRACT' &&
        [
          'DEVICE',
          'TRANS',
          'CREDIT',
          'CASHBACK',
          'LIQUIDATE',
          'PACKAGE',
          'QR',
          'LEND',
          'ONUS',
          'CHANGE',
          'RENT',
          'HOME_PAY_LATER',
          'LINK_CARD',
          'QR_CONNECTOR',
          'NGANLUONG_CONVERT',
        ].includes(typeAppendix)
      return [
        {
          code: this.actCode.VIEW_APPENDIX,
          text: `Xem`,
          icon: 'bx bx-show',
          condition:
            (formContract === 'E_CONTRACT' &&
              (typeAppendix !== 'RENT' ||
                (typeAppendix === 'RENT' && signType === 'SIGN_ECONTRACT'))) ||
            typeAppendix !== 'QR_CONNECTOR' ||
            (typeAppendix === 'QR_CONNECTOR' && signType === 'SIGN_ECONTRACT'),
          action: () => {
            if (isCreatedWithContract) this.$router.push(`/contract-review/${contractId}`)
            else this.$router.push(`/preview-appendix/${contractId}/${appendixId}`)
          },
        },
        {
          code: this.actCode.RE_CREATE_RECEIPT,
          text: 'Sinh lại phiếu thu',
          icon: 'bx bx-file',
          condition: this.canReCreateReceipt(appendixState),
          action: () => this.reCreateRe(appendixId),
        },
        {
          code: this.actCode.APPROVE_REJECT,
          text: 'Duyệt',
          icon: 'bx bx-check-circle',
          condition:
            this.canApproveRejectAppendix(appendixState, contractState, stateCollaborator) &&
            !isCreatedWithContract,
          action: () => {
            const isEContractNL =
              signType === 'SIGN_ECONTRACT' && typeAppendix === 'NGANLUONG_CONVERT'

            const isEContractTL =
              signType === 'SIGN_PCONTRACT' &&
              formContract === 'E_CONTRACT' &&
              typeAppendix === 'LIQUIDATE'

            if (isEContractTL) {
              return this.actionToAppendix({
                appendixId,
                appendixActionType: 'APPENDIX_ACTION_APPROVE',
              }).then(s => s === true && this.showSuccessMx('Đã duyệt thành công'))
            }
            const checkGenpdf = typeAppendix === 'NGANLUONG_CONVERT' ? isEContractNL : isGenPDF

            return this.approveAppendix(
              appendixId,
              checkGenpdf,
              typeAppendix,
              appendixChange,
              appendixRent,
              appendixLend,
              appendixHomePayLater,
              appendixQrConnector,
              appendixLinkCard
            )
          },
        },
        {
          code: this.actCode.APPROVE_REJECT,
          text: 'Từ chối',
          icon: 'bx bx-x-circle',
          condition:
            this.canApproveRejectAppendix(appendixState, contractState, stateCollaborator) &&
            !isCreatedWithContract,
          action: () => this.rejectAppendix(appendixId),
        },
        {
          code: this.actCode.APPROVE_REJECT,
          text: 'SA Từ chối',
          icon: 'bx bx-x-circle',
          condition:
            this.canApproveRejectAppendix_SA(appendixState, typeSale, typeAppendix) &&
            !isCreatedWithContract,
          action: () => this.rejectAppendix(appendixId, appendix),
        },
        {
          code: this.actCode.APPROVE_REJECT_FEE,
          text: 'Duyệt phí',
          icon: 'bx bx-check-circle',
          condition:
            appendixState === 'WAITING_APPROVED_FEE' &&
            ['SALE_DIRECTOR', 'REGION_DIRECTOR'].includes(typeSale) &&
            !isCreatedWithContract &&
            this.canAccessMx('CNPS_SCON_MA_APPROVED_FEE'),
          action: () => this.approveAppendix(appendixId),
        },
        {
          code: this.actCode.APPROVE_REJECT_FEE,
          text: 'Từ chối duyệt phí',
          icon: 'bx bx-x-circle',
          condition:
            appendixState === 'WAITING_APPROVED_FEE' &&
            ['SALE_DIRECTOR', 'REGION_DIRECTOR'].includes(typeSale) &&
            !isCreatedWithContract &&
            this.canAccessMx('CNPS_SCON_MA_APPROVED_FEE'),
          action: () => this.rejectAppendix(appendixId),
        },
        {
          code: this.actCode.APPROVE_REJECT_LIQUID,
          text: 'Duyệt thanh lý',
          icon: 'bx bx-x-circle',
          condition:
            appendixState === 'WAITING_APPROVED_FEE' &&
            ['SALE_DIRECTOR', 'REGION_DIRECTOR'].includes(typeSale) &&
            !isCreatedWithContract &&
            this.canAccessMx('CNPS_SCON_MA_APPROVED_FEE'),
          action: () => this.approveAppendix(appendixId),
        },
        {
          code: this.actCode.APPROVE_REJECT_LIQUID,
          text: 'Từ chối duyệt thanh lý',
          icon: 'bx bx-x-circle',
          condition:
            appendixState === 'WAITING_APPROVED_FEE' &&
            ['SALE_DIRECTOR', 'REGION_DIRECTOR'].includes(typeSale) &&
            !isCreatedWithContract &&
            this.canAccessMx('CNPS_SCON_MA_APPROVED_FEE'),
          action: () => this.rejectAppendix(appendixId),
        },
        {
          code: this.actCode.REQUEST_ADDITIONAL,
          text: 'Cần bổ sung',
          icon: 'bx bx-plus-circle',
          condition:
            appendixState === 'SIGNED_WAITING_APPROVED' &&
            !isCreatedWithContract &&
            (this.canAccessMx('CNPS_SCON_REQUEST_ADDITIONAL_IMAGE') ||
              this.canAccessMx('CNPS_SCON_APPROVE_TINGBOX_CONTRACT')),
          action: () => this.additionalAppendix(appendixId, typeAppendix),
        },
        {
          code: this.actCode.REQUEST_ADDITIONAL_OPTION,
          text: 'Cần bổ sung',
          icon: 'bx bx-plus-circle',
          condition:
            appendixState === 'SIGNED_WAITING_APPROVED' &&
            !isCreatedWithContract &&
            // this.canAccessMx('CNPS_SCON_REQUEST_ADDITIONAL_IMAGE'),
            (this.canAccessMx('CNPS_SCON_REQUEST_ADDITIONAL_IMAGE') ||
              this.canAccessMx('CNPS_SCON_APPROVE_TINGBOX_CONTRACT')),
          action: () => this.additionalAppendixOptionAdditional(appendixId, typeAppendix),
        },
        {
          code: this.actCode.OTP,
          text: 'Gửi lại OTP qua SMS',
          condition:
            appendixState === 'SIGNING' &&
            this.canAccessMx('CNPS_SCON_GET_OTP') &&
            !isCreatedWithContract,
          action: () => this.resendOTP('RESEND_OTP', appendixId),
        },
        {
          code: this.actCode.OTP,
          text: 'Gửi lại OTP qua Zalo',
          condition:
            appendixState === 'SIGNING' &&
            this.canAccessMx('CNPS_SCON_GET_OTP') &&
            !isCreatedWithContract,
          action: () => this.resendOTP('RESEND_OTP', appendixId, true),
        },
        {
          code: this.actCode.OTP,
          text: 'Nội dung OTP',
          condition:
            appendixState === 'SIGNING' &&
            this.canAccessMx('CNPS_SCON_GET_OTP') &&
            !isCreatedWithContract,
          action: () => this.resendOTP('GET_CONTENT', appendixId),
        },
        {
          code: this.actCode.EDIT_DEVICE,
          text: 'Sửa',
          icon: 'bx bx-pen',
          condition: appendixState === 'SIGNED_WAITING_APPROVED',
          action: () => this.showEditDevice(appendix),
        },
        {
          code: this.actCode.REMOVE_DEVICE,
          text: 'Gỡ thiết bị',
          icon: 'bx bx-x-circle',
          condition:
            (this.canAccessMx('CNPS_SCON_SA_APPROVED_APPENDIX') ||
              this.canAccessMx('CNPS_SCON_APPROVE_TINGBOX_CONTRACT')) &&
            !isCreatedWithContract &&
            appendixState === 'REJECTED_SA',
          action: () => this.removeDevice('APPENDIX', appendixId),
        },
        {
          code: this.actCode.CREATE_APPENDIX_VISA,
          text: 'Sửa',
          icon: 'bx bx-pen',
          condition: true,
          action: () => {
            this.showModalComponentMx('Phụ lục VISA', {
              name: formAppendixVisa,
              props: {
                items: appendix.appendixVisa.pdfs,
                appendixId,
              },
              id: 'formAppendixVisa',
              footerClass: 'd-none',
            }).then(_ => this.getDetailContract())
          },
        },
        {
          code: this.actCode.REJECT_VISA,
          text: 'Từ chối PL phí Visa',
          icon: 'bx bx-x-circle',
          condition:
            this.canAccessMx('CNPS_SCON_REJECT_VISA_APPENDIX') &&
            ['APPROVED', 'PENDING_APPROVAL', 'ACTIVE'].includes(appendixState) &&
            appendix.mposStt === 'NOT_CONFIGURED',
          action: () => this.rejectAppendixVisa(appendixId),
        },
        {
          code: this.actCode.HANOVER_APPROVE_REJECT,
          text: 'Duyệt xác nhận bàn giao',
          icon: 'bx bx-check-circle',
          condition:
            appendix.statusHandover === 'WAIT_APPROVE' &&
            this.canAccessMx('CNPS_SCON_APPENDIX_HANDLE_HANDOVER_DEVICE'),
          action: () =>
            this.confirmHandover('Duyệt xác nhận bàn giao', {
              action: 'SUCCESS',
              contractId: appendixId,
              contractType: 'APPENDIX',
            }),
        },
        {
          code: this.actCode.HANOVER_APPROVE_REJECT,
          text: 'Từ chối xác nhận bàn giao',
          icon: 'bx bx-x-circle',
          condition:
            appendix.statusHandover === 'WAIT_APPROVE' &&
            this.canAccessMx('CNPS_SCON_APPENDIX_HANDLE_HANDOVER_DEVICE'),
          action: () =>
            this.confirmHandover('Từ chối xác nhận bàn giao', {
              action: 'REJECTED',
              contractId: appendixId,
              contractType: 'APPENDIX',
            }),
        },
        {
          code: this.actCode.HANOVER_APPROVE_REJECT_NEW,
          text: 'Duyệt xác nhận bàn giao',
          icon: 'bx bx-check-circle',
          condition:
            appendix.statusHandover === 'WAIT_APPROVE' &&
            this.canAccessMx('CNPS_SCON_APPENDIX_HANDLE_HANDOVER_DEVICE'),
          action: () =>
            this.handleConfirmHandover(
              'Xem xác nhận bàn giao',
              {
                contractId: appendixId,
                contractType: 'APPENDIX',
                contractCode: this.dataContract?.code,
              },
              {
                email: this.dataContract?.customerInfoCommon?.email,
                appendixId: appendixId,
              }
            ),
        },
        {
          code: this.actCode.MULTI_FUNCTIONAL_APPROVE_REJECT,
          text: 'Duyệt nội dung',
          icon: 'bx bx-check-circle',
          condition:
            appendixState === 'WAITING_APPROVED_FEE' &&
            this.canAccessMx('CNPS_SCON_MA_APPROVED_MFN_APPENDIX'),
          action: () =>
            this.confirmMultiFunctional('Duyệt nội dung', {
              appendixId: appendixId,
              isMerchantAgree: true,
            }),
        },
        {
          code: this.actCode.MULTI_FUNCTIONAL_APPROVE_REJECT,
          text: 'Từ chối duyệt nội dung',
          icon: 'bx bx-x-circle',
          condition:
            appendixState === 'WAITING_APPROVED_FEE' &&
            this.canAccessMx('CNPS_SCON_MA_APPROVED_MFN_APPENDIX'),
          action: () =>
            this.confirmMultiFunctional('Từ chối duyệt nội dung', {
              appendixId: appendixId,
              isMerchantAgree: false,
            }),
        },
        {
          code: this.actCode.CONFIRM_INFO_APPENDIX,
          text: 'Xác nhận thẩm định',
          icon: 'bx bx-check-circle',
          condition: appendixState === 'APPROVED' && appraisalStatus === 'UNDETERMINED',
          action: () =>
            this.confirmInfoAppendix('Xác nhận thẩm định', {
              appendixId: appendixId,
              appendixActionType: 'APPENDIX_ACTION_APPROVE',
            }),
        },
        {
          code: this.actCode.REQUEST_ADDITIONAL_INFO,
          text: 'Yêu cầu bổ sung',
          icon: 'bx bx-plus-circle',
          condition: appendixState === 'APPROVED' && appraisalStatus === 'UNDETERMINED',
          action: () =>
            this.requestAdditionalInfo(
              {
                appendixId: appendixId,
                appendixActionType: 'APPENDIX_ACTION_ADD_INFO',
              },
              typeAppendix
            ),
        },

        {
          code: this.actCode.ADD_VIETQR_FEE_330,
          text: 'Thêm điều khoản VietQR cố định 330đ',
          icon: 'bx bx-check-circle',
          condition:
            this.canAccessMx('CNPS_SCON_APPROVED_CONTRACT') &&
            this.canUseVietQRFee(typeCustomer, appendixState),
          action: () => this.addVietQrFee(appendixId, 'VIET_QR_330'),
        },
        {
          code: this.actCode.REMOVE_VIETQR_FEE_330,
          text: 'Xóa điều khoản VietQR cố định 330đ',
          icon: 'bx bx-x-circle',
          condition:
            this.canAccessMx('CNPS_SCON_APPROVED_CONTRACT') &&
            this.canUseVietQRFee(typeCustomer, appendixState),
          action: () => this.removeVietQrFee(appendixId, 'VIET_QR_330'),
        },
        {
          code: this.actCode.ADD_VIETQR_FEE_550,
          text: 'Thêm điều khoản VietQR cố định 550đ',
          icon: 'bx bx-check-circle',
          condition:
            this.canAccessMx('CNPS_SCON_APPROVED_CONTRACT') &&
            this.canUseVietQRFee(typeCustomer, appendixState),
          action: () => this.addVietQrFee(appendixId, 'VIET_QR_550'),
        },
        {
          code: this.actCode.REMOVE_VIETQR_FEE_550,
          text: 'Xóa điều khoản VietQR cố định 550đ',
          icon: 'bx bx-x-circle',
          condition:
            this.canAccessMx('CNPS_SCON_APPROVED_CONTRACT') &&
            this.canUseVietQRFee(typeCustomer, appendixState),
          action: () => this.removeVietQrFee(appendixId, 'VIET_QR_550'),
        },
        {
          code: this.actCode.CHANGE_FILE_APPENDIX_MPOS,
          text: 'Đổi file phụ lục & đẩy MPOS',
          icon: 'bx bx-file',
          condition:
            this.canAccessMx('CNPS_SCON_APPENDIX_CHANGE_FILE') && appendixState === 'APPROVED',
          action: () => this.actionSelectFileAppendixMpos(appendixId),
        },
        {
          code: 'CHANGE_FILE_NGANLUONG_CONVERT',
          text: 'Đổi file HĐ Ngân Lượng/Đẩy MPOS',
          icon: 'bx bx-file',
          // condition: true,
          condition:
            // this.canAccessMx('CNPS_SCON_UPDATE_SIGNED_NGANLUONG_CONTRACT') &&
            ['APPROVED', 'SIGNED_WAITING_APPROVED', 'ACTIVE'].includes(appendixState) &&
            typeAppendix === 'NGANLUONG_CONVERT',
          action: () => {
            if (this.$refs.updateNlConvertModal) {
              this.$refs.updateNlConvertModal.show(appendix)
            }
          },
        },
      ]
    },
    async historySaleAssigned() {
      try {
        const response = await SalesManagerService.assignSaleHistory({
          contractId: this.$route.params.id,
        })
        if (response.code === 1000) {
          this.historyAssignSale = response.data
        }
      } catch (error) {
        console.log(error)
      }
    },
    async getHistoryUpdate() {
      try {
        const response = await SalesManagerService.historyUpdateCus({
          contractId: this.dataContract.id,
        })
        if (response.code === 1000) this.historyUpdate = response.data
      } catch (error) {
        console.log(error)
      }
    },
    configSystem() {
      return CommonService.getConfigSystem()
        .then(data => {
          if (data.success) {
            this.dataConfigMcc = data.data.businessFields.map(e => ({ id: e.code, text: e.name }))
            this.dataMotoAppendixAdditionalReason = data.data.motoAppendixAdditionalReason.map(
              e => ({ id: e.name, text: e.name })
            )
            this.dataMultiFuncAppendixAdditionalReason =
              data.data.multiFuncAppendixAdditionalReason.map(e => ({ id: e.name, text: e.name }))
            this.cfgPolicyContract = data.data.cfgPolicyContract.map(e => ({
              id: e.code,
              text: e.name,
            }))
          }
        })
        .catch(error => console.log(error))
    },
    async hasDeviceContract(devices, cashbacks) {
      const getLength = (appendix, variable) => {
        return (
          appendix
            .filter(
              s => !['REJECTED_SA', 'REJECTED_MC', 'REJECTED_MA', 'CANCELED'].includes(s.state)
            )
            .map(s => s[variable].deviceInfos)
            .flat().length ?? 0
        )
      }
      const lnDevice = getLength(devices ?? [], 'appendixDevice')
      const lnCashback = getLength(cashbacks ?? [], 'appendixCashback')
      if (lnDevice !== 0 || lnCashback !== 0)
        return await this.approveMx(
          `Xác nhận gỡ ${lnDevice + lnCashback} thiết bị khỏi hợp đồng/phụ lục [${this.dataContract.code}] ?`
        ).then(s => s === true)
      return null
    },
    // FOR APPENDIX
    async getAppendixUrl(appendixId, typeAppendix) {
      try {
        const dataAppendix = await ContractService.getAppendixById({ appendixId }).then(
          s => s.data.data
        )
        if (
          dataAppendix.signatureOfMerchantByAppendix?.length > 0 ||
          ['NGANLUONG_CONVERT'].includes(typeAppendix)
        ) {
          const params = {
            token: this.dataUser.token,
            code: this.dataContract.code,
            groupService: this.dataContract.groupService,
            typeAppendix: Config.mappingTypeAppendix[typeAppendix],
            appendixId,
          }
          const response = await ContractService.genPDFByServer_Appendix(params)
          if (response.code === 1000) {
            return `${window._env_?.VUE_APP_GET_CCRP_CONFIG ?? process.env.VUE_APP_GET_CCRP_CONFIG}/file/${response.message}`
          } else this.showFailMx(response.message)
        } else this.showFailMx('Không có chữ ký phụ lục')
      } catch (error) {
        this.showFailMx(error)
      }
    },
    async approveAppendix(
      appendixId,
      isGenPDF = false,
      typeAppendix = null,
      appendixChange,
      appendixRent,
      appendixLend,
      appendixHomePayLater,
      appendixQrConnector,
      appendixLinkCard
    ) {
      const validateSignForm = appendix =>
        appendix && (!appendix.signForm || appendix.signForm == null)
      if (
        validateSignForm(appendixChange) ||
        validateSignForm(appendixRent) ||
        validateSignForm(appendixLend) ||
        validateSignForm(appendixHomePayLater) ||
        validateSignForm(appendixQrConnector) ||
        validateSignForm(appendixLinkCard)
      ) {
        this.showFailMx('Chưa chọn hình thức ký')
        return
      }
      const flag = await this.approveMx('Nhấn Xác nhận để duyệt!')
      if (flag !== true) return

      const params = {
        appendixId,
        appendixActionType: 'APPENDIX_ACTION_APPROVE',
      }
      if (isGenPDF && this.dataContract.typeCustomer !== 'COMPANY') {
        const requiresUrl = [
          appendixChange,
          appendixRent,
          appendixLend,
          appendixHomePayLater,
          appendixQrConnector,
          appendixLinkCard,
        ].every(appendix => !appendix)
          ? true
          : [
              appendixChange,
              appendixRent,
              appendixLend,
              appendixHomePayLater,
              appendixQrConnector,
              appendixLinkCard,
            ].some(appendix => appendix && appendix.signForm === 'E_CONTRACT')
        if (requiresUrl) {
          this.showLoading = true
          const url = await this.getAppendixUrl(appendixId, typeAppendix)
          if (!url) {
            this.showLoading = false
            return
          }
          params.urlS3 = url
        }
      }
      this.actionToAppendix(params).then(
        s => s === true && this.showSuccessMx('Đã duyệt thành công')
      )
    },
    async additionalAppendix(appendixId) {
      const { value: flag, note } = await this.rejectMx('Lý do cần bổ sung')
      if (flag !== true) return
      this.actionToAppendix({
        appendixId,
        appendixActionType: 'APPENDIX_ACTION_ADD_INFO',
        reasonAddInfo: [note],
      }).then(s => s === true && this.showSuccessMx('YC cần bổ sung thành công'))
    },

    async additionalAppendixOptionAdditional(appendixId, typeAppendix) {
      const optionAdditional =
        typeAppendix === 'MOTO'
          ? this.dataMotoAppendixAdditionalReason
          : (typeAppendix = 'MULTI_FUNCTIONAL' ? this.dataMultiFuncAppendixAdditionalReason : [])
      const {
        value: flag,
        note,
        noteReason,
      } = await this.requestAdditionalOptionMx(optionAdditional)
      if (flag !== true) return
      this.actionToAppendix({
        appendixId,
        appendixActionType: 'APPENDIX_ACTION_ADD_INFO',
        reasonAddInfo: [note],
        noteReasonAddInfo: noteReason,
      }).then(s => s === true && this.showSuccessMx('YC cần bổ sung thành công'))
    },
    async rejectAppendix(appendixId, appendix = null) {
      let message = ''
      if (appendix) {
        message = this.checkRequestApproveNewBranch(appendix)
      }

      if (message != '') {
        return this.showFailMx(message).then(async () => {
          const { value: flag, note } = await this.rejectMx()
          if (flag !== true) return
          this.actionToAppendix({
            appendixId,
            appendixActionType: 'APPENDIX_ACTION_REJECT',
            reasonRejected: [note],
          }).then(s => s === true && this.showSuccessMx('Đã từ chối thành công'))
        })
      }

      const { value: flag, note } = await this.rejectMx()
      if (flag !== true) return
      this.actionToAppendix({
        appendixId,
        appendixActionType: 'APPENDIX_ACTION_REJECT',
        reasonRejected: [note],
      }).then(s => s === true && this.showSuccessMx('Đã từ chối thành công'))
    },
    async rejectAppendixVisa(appendixId) {
      const { value: flag, note } = await this.rejectMx()
      if (flag !== true) return
      try {
        this.showLoading = true
        const response = await ContractService.rejectAppendixVisa({ appendixId, reason: note })
        if (response.code === 1000) {
          this.getDetailContract()
          return true
        } else {
          this.showFailMx(response.message ?? response.error)
        }
      } catch (error) {
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },
    async confirmHandover(text, params) {
      const flag = await this.approveMx(text)
      if (flag !== true) return
      try {
        this.showLoading = true
        const response = await ContractService.confirmHandleHandover(params)
        if (response.success) {
          this.getDetailContract()
          this.showSuccessMx(text + ' thành công')
          this.$refs['modal-confirm']?.hide()
        } else {
          this.showFailMx(response.message ?? response.error)
        }
      } catch (error) {
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },
    async handleConfirmHandover(text, params, additionalParams) {
      try {
        this.selectedItem = null
        this.showLoading = true
        const response = await DeviceService.getDeviceInContract(params)
        if (response.code === 1000) {
          this.selectedItem = response.data
          this.selectedItem.merchantEmail = additionalParams.email
          this.selectedItem.appendixId = additionalParams.appendixId
          this.showLoading = false
          if (response.data.images && response.data.images.length > 0) {
            this.images = response.data.images
            this.disableBtn = false
          }
          this.$refs['modal-confirm']?.show()
        } else {
          this.showFailMx(response.message ?? response.error)
        }
      } catch (error) {
        console.log('error::: ', error)
        this.showFailMx(error.message ?? error)
      } finally {
        this.showLoading = false
      }
    },
    async confirmMultiFunctional(text, params) {
      const flag = await this.approveMx(text)
      if (flag !== true) return
      try {
        this.showLoading = true
        const response = await ContractService.confirmMultiFunctional(params)
        if (response.success) {
          await this.getDetailContract()
          this.showSuccessMx(text + ' thành công')
        } else {
          this.showFailMx(response.message ?? response.error)
        }
      } catch (error) {
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },
    async confirmInfoAppendix(text, params) {
      const flag = await this.approveMx(text)
      if (flag !== true) return
      try {
        this.showLoading = true
        const response = await ContractService.confirmInfoAppendix(params)
        if (response.success) {
          await this.getDetailContract()
          this.showSuccessMx(response.message)
        } else {
          this.showFailMx(response.message ?? response.error)
        }
      } catch (error) {
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },
    async requestAdditionalInfo(params, typeAppendix) {
      const optionAdditional =
        typeAppendix === 'MOTO'
          ? this.dataMotoAppendixAdditionalReason
          : (typeAppendix = 'MULTI_FUNCTIONAL' ? this.dataMultiFuncAppendixAdditionalReason : [])
      const {
        value: flag,
        note,
        noteReason,
      } = await this.requestAdditionalOptionMx(optionAdditional)
      if (flag !== true) return
      try {
        params.reasonAddInfo = [note]
        params.noteReasonAddInfo = noteReason
        this.showLoading = true
        const response = await ContractService.confirmInfoAppendix(params)
        if (response.success) {
          await this.getDetailContract()
          this.showSuccessMx(response.message)
        } else {
          this.showFailMx(response.message ?? response.error)
        }
      } catch (error) {
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },
    async actionToAppendix(params) {
      try {
        this.showLoading = true
        const response = await ContractService.actionAppendix(params)
        if (response.success && response.code === 1000) {
          await this.getDetailContract()
          return true
        } else {
          this.showFailMx(response.message ?? response.error)
        }
      } catch (error) {
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },
    // END FOR APPENDIX
    // FOR PAPER CONTRACT
    async additionalPaperContract() {
      const { value: flag, note } = await this.rejectMx('Lý do cần bổ sung')
      if (flag !== true) return
      this.actionToPaperContract({
        contractId: this.dataContract.id,
        paperActionType: 'PAPER_ACTION_ADD_INFO',
        reasonAddInfo: note,
      }).then(s => s === true && this.showSuccessMx('YC cần bổ sung thành công'))
    },
    async expertisePaperContract() {
      const flag = await this.approveMx('Nhấn Xác nhận để gửi thẩm định!')
      if (flag !== true) return
      this.actionToPaperContract({
        contractId: this.dataContract.id,
        paperActionType: 'PAPER_ACTION_EXPERTISE',
      }).then(s => s === true && this.showSuccessMx('Đã gửi thẩm định thành công'))
    },
    async approvePaperContract() {
      const flag = await this.approveMx('Nhấn Xác nhận để duyệt!')
      if (flag !== true) return
      this.actionToPaperContract({
        contractId: this.dataContract.id,
        paperActionType: 'PAPER_ACTION_APPROVE',
      }).then(s => s === true && this.showSuccessMx('Đã duyệt thành công'))
    },
    async rejectPaperContract(checkDevice = false) {
      const params = { contractId: this.dataContract.id }
      if (checkDevice) {
        const agreeRemoveDevice = await this.hasDeviceContract(
          this.dataContract.appendixDevices,
          this.dataContract.appendixCashbacks
        )
        if (agreeRemoveDevice !== null) params.agreeRemoveDevice = agreeRemoveDevice
      }
      const { value: flag, note } = await this.rejectMx()
      if (flag !== true) return
      params.reasonRejected = note
      try {
        this.showLoading = true
        const response = await ContractService.rejectPaperContract(params)
        if (response.code === 1000) {
          this.getDetailContract()
          this.showSuccessMx('Đã từ chối thành công')
        } else {
          this.showFailMx(response.message ?? response.error)
        }
      } catch (error) {
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },
    async actionToPaperContract(params) {
      try {
        this.showLoading = true
        const response = await ContractService.actionPaperContract(params)
        if (response.code === 1000) {
          this.getDetailContract()
          return true
        } else {
          this.showFailMx(response.message ?? response.error)
        }
      } catch (error) {
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },
    async removeDevice(type, id) {
      try {
        const flag = await this.approveMx('Nhấn Xác nhận để gỡ thiết bị!')
        if (flag !== true) return
        this.showLoading = true
        const params = {
          sconId: id,
          type,
        }
        const response = await ContractService.removeDevice(params)
        if (response.code === 1000) {
          this.getDetailContract()
          this.showSuccessMx('Gỡ thiết bị thành công!')
          return true
        } else {
          this.showFailMx(response.message ?? response.error)
        }
      } catch (error) {
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },
    async onVinvoice(customerId) {
      try {
        const flag = await this.approveMx('Bật nhận hóa đơn tự động')
        if (flag !== true) return
        this.showLoading = true
        const params = {
          enableSendMonthlyReport: true,
          customerId,
        }
        const response = await ContractService.onOffVinvoice(params)
        if (response.code === 1000) {
          this.getDetailContract()
          this.showSuccessMx('Bật nhận hóa đơn tự động thành công')
          return true
        } else {
          this.showFailMx(response.message ?? response.error)
        }
      } catch (error) {
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },
    async offVinvoice(customerId) {
      try {
        const flag = await this.approveMx('Tắt nhận hóa đơn tự động')
        if (flag !== true) return
        this.showLoading = true
        const params = {
          enableSendMonthlyReport: false,
          customerId,
        }
        const response = await ContractService.onOffVinvoice(params)
        if (response.code === 1000) {
          this.getDetailContract()
          this.showSuccessMx('Tắt nhận hóa đơn tự động thành công')
          return true
        } else {
          this.showFailMx(response.message ?? response.error)
        }
      } catch (error) {
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },
    async confirmPolicyEcontract(contractId, isMerchantAgree) {
      try {
        const flag = await this.approveMx(
          isMerchantAgree ? 'Duyệt nội dung hợp đồng' : 'Từ chối nội dung hợp đồng'
        )
        if (flag !== true) return
        this.showLoading = true
        const params = {
          contractId,
          isMerchantAgree,
        }
        console.log(params)
        const response = await ContractService.policyEcontract(params)
        if (response.result) {
          this.getDetailContract()
          this.showSuccessMx(
            isMerchantAgree
              ? 'Duyệt nội dung hợp đồng thành công'
              : 'Từ chối nội dung hợp đồng thành công'
          )
          return true
        } else {
          this.showFailMx(response.message ?? response.error)
        }
      } catch (error) {
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },

    async changeApproveTwo(contractId) {
      try {
        const flag = await this.approveMx('Xác nhận chuyển chờ duyệt')
        if (!flag) return
        this.showLoading = true
        const response = await ContractService.changeApprovedTwo({
          contractId: contractId,
        })
        if (response.code === 1000) {
          this.showSuccessMx(response.message)
          this.getDetailContract()
        } else {
          this.showFailMx(response.message ?? response.error)
        }
      } catch (error) {
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },
    async changeApproveTwoS2(contractId) {
      try {
        const flag = await this.approveMx('Xác nhận chuyển về đã duyệt')
        if (!flag) return
        this.showLoading = true
        const response = await ContractService.changeApprovedTwoS2({
          contractId: contractId,
        })
        if (response.code === 1000) {
          this.showSuccessMx(response.message)
          this.getDetailContract()
        } else {
          this.showFailMx(response.message ?? response.error)
        }
      } catch (error) {
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },
    async changeApproveRejectMpos(contractId) {
      try {
        const flag = await this.approveMx('Xác nhận Từ chối HĐ MPOS MC Đang Hoạt Động, Ký lại')
        if (!flag) return
        this.showLoading = true
        const response = await ContractService.changeApproveRejectMpos({
          contractId: contractId,
        })
        if (response.code === 1000) {
          this.showSuccessMx(response.message)
          this.getDetailContract()
        } else {
          this.showFailMx(response.message ?? response.error)
        }
      } catch (error) {
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },
    // END FOR PAPER CONTRACT
    // FOR E-CONTRACT
    async additionalContract() {
      const { value: flag, note } = await this.rejectMx('Lý do cần bổ sung')
      if (flag !== true) return
      try {
        this.showLoading = true
        const response = await ContractService.additionalContract({
          contractId: this.dataContract.id,
          reasonAddImage: [note],
        })
        if (response.code === 1000) {
          this.getDetailContract()
          this.showSuccessMx('YC cần bổ sung thành công')
        } else {
          this.showFailMx(response.message ?? response.error)
        }
      } catch (error) {
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },
    async rejectFeeContract() {
      const { value: flag, note } = await this.rejectMx()
      if (flag !== true) return
      try {
        this.showLoading = true
        const response = await ContractService.approvedAppendixWithContract({
          contractId: this.dataContract.id,
          isSaleApproveFee: false,
          managerSaleId: this.dataUser.userId,
          reasonRejected: note,
        })
        if (response.code === 1000) {
          this.getDetailContract()
          this.showSuccessMx('Đã từ chối thành công')
        } else {
          this.showFailMx(response.message ?? response.error)
        }
      } catch (error) {
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },
    async rejectContractMpos() {
      const { value: flag, note } = await this.rejectMx()
      if (flag !== true) return
      try {
        this.showLoading = true
        const response = await ContractService.rejectContractMpos({
          id: this.dataContract.id,
          reasonRejected: [note],
          type: 'TYPE_CONTRACT',
        })
        if (response.code === 1000) {
          this.getDetailContract()
          this.showSuccessMx('Đã từ chối thành công')
        } else {
          this.showFailMx(response.message ?? response.error)
        }
      } catch (error) {
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },
    async approveContract() {
      const flag = await this.approveMx('Nhấn Xác nhận để duyệt!')
      if (flag !== true) return
      try {
        this.showLoading = true
        let urlContractS3 = ''
        if (this.dataContract.typeCustomer !== 'COMPANY') {
          if (this.dataContract.signatureOfMerchantByContract.length > 0) {
            const response = await ContractService.genPDFByServer({
              token: this.dataUser.token,
              code: this.dataContract.code,
              groupService: this.dataContract.groupService,
            })
            if (response.code === 1000)
              urlContractS3 = `${window._env_?.VUE_APP_GET_CCRP_CONFIG ?? process.env.VUE_APP_GET_CCRP_CONFIG}/file/${response.message}`
          } else {
            this.showFailMx('Không có chữ ký hợp đồng')
          }
        }
        const saveLink = await ContractService.saveLinkPFD({
          econtractId: this.dataContract.id,
          urlS3: urlContractS3,
        })
        if (saveLink.code === 1000) {
          this.getDetailContract()
          this.showSuccessMx('Duyệt HĐ thành công')
        } else {
          this.showFailMx(saveLink.message ?? saveLink.error)
        }
      } catch (error) {
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },
    async editUsername(userNameStr, appendixId) {
      const { value: flag, note } = await this.rejectMx('Sửa username', userNameStr)
      if (flag !== true) return
      try {
        this.showLoading = true
        const res = await SalesManagerService.editUsername({
          userNameStr: note,
          appendixId: appendixId,
        })
        if (res.success === true) {
          await this.getDetailContract()
          this.showSuccessMx('Sửa username thành công')
        } else this.showFailMx(res.message ?? res.error)
      } catch (error) {
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },
    approveFeeContract() {
      return this.dataContract.groupService === 'SELL'
        ? this.approveFeeContractSale()
        : this.approveFeeContractPayment()
    },
    rejectContract() {
      return this.dataContract.groupService === 'SELL'
        ? this.rejectContractSale(false)
        : this.rejectContractPayment(true)
    },
    // END FOR E-CONTRACT
    // FOR E-CONTRACT PAYMENT
    async approveFeeContractPayment() {
      const flag = await this.approveMx('Nhấn Xác nhận để duyệt!')
      if (flag !== true) return
      try {
        this.showLoading = true
        const response = await ContractService.approvedAppendixWithContract({
          contractId: this.dataContract.id,
          isSaleApproveFee: true,
          managerSaleId: this.dataUser.userId,
        })
        if (response.code === 1000) {
          this.getDetailContract()
          this.showSuccessMx('Đã duyệt thành công')
        } else {
          this.showFailMx(response.message ?? response.error)
        }
      } catch (error) {
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },
    async rejectContractPayment(checkDevice = false) {
      const params = { code: this.dataContract.code }
      if (checkDevice) {
        const agreeRemoveDevice = await this.hasDeviceContract(
          this.dataContract.lstAppendixDevices,
          this.dataContract.lstAppendixCashbacks
        )
        if (agreeRemoveDevice !== null) params.agreeRemoveDevice = agreeRemoveDevice
      }
      const { value: flag, note } = await this.rejectMx()
      if (flag !== true) return
      params.reasonRejected = note
      try {
        this.showLoading = true
        const response = await ContractService.rejectContract(params)
        if (response.code === 1000) {
          this.getDetailContract()
          this.showSuccessMx('Đã từ chối thành công')
        } else {
          this.showFailMx(response.message ?? response.error)
        }
      } catch (error) {
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },
    // END FOR E-CONTRACT PAYMENT
    // FOR E-CONTRACT SALE
    async approveFeeContractSale() {
      const flag = await this.approveMx('Nhấn Xác nhận để duyệt!')
      if (flag !== true) return
      try {
        this.showLoading = true
        const response = await SalesManagerService.approvedAppendixWithContract({
          id: this.dataContract.id,
          isSaleApproveFee: true,
          managerSaleId: this.dataUser.userId,
          type: 'TYPE_CONTRACT',
        })
        if (response.code === 1000) {
          this.getDetailContract()
          this.showSuccessMx('Đã duyệt thành công')
        } else {
          this.showFailMx(response.message ?? response.error)
        }
      } catch (error) {
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },
    async rejectContractSale(checkDevice = false) {
      const params = {
        id: this.dataContract.id,
        typeRejected: 'TYPE_CONTRACT',
      }
      if (checkDevice) {
        const agreeRemoveDevice = await this.hasDeviceContract(
          this.dataContract.lstAppendixDevices,
          this.dataContract.lstAppendixCashbacks
        )
        if (agreeRemoveDevice !== null) params.agreeRemoveDevice = agreeRemoveDevice
      }
      const { value: flag, note } = await this.rejectMx()
      if (flag !== true) return
      params.reasonRejected = note
      try {
        this.showLoading = true
        const response = await SalesManagerService.rejectSAContract(params)
        if (response.code === 1000) {
          this.getDetailContract()
          this.showSuccessMx('Đã từ chối thành công')
        } else {
          this.showFailMx(response.message ?? response.error)
        }
      } catch (error) {
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },
    // END FOR E-CONTRACT SALE
    additional() {
      return this.dataContract.formContract === 'E_CONTRACT'
        ? this.additionalContract()
        : this.additionalPaperContract()
    },
    rejectMpos() {
      return this.dataContract.formContract === 'E_CONTRACT'
        ? this.rejectContractMpos()
        : this.rejectPaperContract()
    },
    rejectFee() {
      return this.dataContract.formContract === 'E_CONTRACT'
        ? this.rejectFeeContract()
        : this.rejectPaperContract()
    },
    reject() {
      return this.dataContract.formContract === 'E_CONTRACT'
        ? this.rejectContract()
        : this.rejectPaperContract(true)
    },
    approve() {
      // return this.dataContract.formContract === "E_CONTRACT" ? this.approveContract() : this.approvePaperContract()
      return this.$refs.popupApproveContractRef?.show(this.dataContract)
    },
    approveFee() {
      return this.dataContract.formContract === 'E_CONTRACT'
        ? this.approveFeeContract()
        : this.approvePaperContract()
    },
    async approveCollaborator() {
      const flag = await this.approveMx('Nhấn Xác nhận để duyệt!')
      if (flag !== true) return
      this.actionCollaborator({
        contractId: this.dataContract.id,
        action: 'APPROVED',
      }).then(s => s === true && this.showSuccessMx('Đã duyệt thành công'))
    },
    async rejectCollaborator() {
      const { value: flag, note } = await this.rejectMx()
      if (flag !== true) return
      this.actionCollaborator({
        contractId: this.dataContract.id,
        action: 'REJECTED',
        reasonReject: note,
      }).then(s => s === true && this.showSuccessMx('Đã từ chối thành công'))
    },
    async actionCollaborator(params) {
      try {
        this.showLoading = true
        const response = await ContractService.actionCollaborator(params)
        if (response.code === 1000) {
          this.getDetailContract()
          return true
        } else {
          this.showFailMx(response.message ?? response.error)
        }
      } catch (error) {
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },
    async submitEditMcc(mcc, mccDetail) {
      const mccText = this.dataConfigMcc.find(s => s.id === mcc)?.text
      const flag = await this.approveMx(
        `Bạn có chắc muốn đổi sang ngành hàng ${mccText} này không?`
      )
      if (flag !== true) return
      try {
        this.showLoading = true
        const params = {
          mcc: mcc,
          mccDetail: mccDetail,
          customerId: this.customerInfo.customerId,
          servicePackCode: this.dataContract.groupService,
          listServices: this.dataContract.serviceTypes ?? [this.dataContract.service],
        }
        const response = await ContractService.editMccMerchant(params)
        if (response.code === 1000) {
          if (this.dataContract.formContract !== 'E_CONTRACT') {
            const rs = await ContractService.updateMccMerchantPaperContract({
              contractId: this.dataContract.id,
              customerId: this.dataContract.customerId,
            })
            if (rs.success === true || rs.result === true) {
              this.showSuccessMx('Thay đổi ngành hàng thành công !')
              this.getDetailContract()
              return
            }
            this.showFailMx(response.message ?? response.error)
            return
          }
          this.showSuccessMx('Thay đổi ngành hàng thành công !')
          this.canEditMcc = false
          this.getDetailContract()
        }
      } catch (error) {
        this.showFailMx(error.message)
      } finally {
        this.showLoading = false
      }
    },
    async assignNewSale(sale) {
      try {
        this.showLoading = true
        const response = await ContractService.assignNewSale({
          contractId: this.$route.params.id,
          emailAssign: sale.userName,
        })
        if (response.code === 1000) {
          this.showSuccessMx(response.message)
        } else {
          this.showFailMx(response.message ?? response.error)
        }
      } catch (error) {
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },
    async reCreateRe(appendixId) {
      try {
        this.showLoading = true
        const response = await SalesManagerService.reCreateReceipt({ appendixId })
        if (response.code === 1000) {
          this.showSuccessMx(response.message)
        } else {
          this.showFailMx(response.message ?? response.error)
        }
      } catch (error) {
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },
    async reCreate() {
      try {
        this.showLoading = true
        const response = await SalesManagerService.reCreateReceipt({
          contractId: this.$route.params.id,
        })
        if (response.code === 1000) {
          this.showSuccessMx(response.message)
        } else {
          this.showFailMx(response.message ?? response.error)
        }
      } catch (error) {
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },
    async changeContractState() {
      try {
        const { value: flag, note } = await this.rejectMx('Nhập lý do chuyển chờ duyệt')
        if (!flag) return
        this.showLoading = true
        const response = await ContractService.rollbackContractState({
          id: this.dataContract.id,
          reason: note,
        })
        if (response.code === 1000) {
          this.showSuccessMx(response.message)
          this.getDetailContract()
        } else {
          this.showFailMx(response.message ?? response.error)
        }
      } catch (error) {
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },
    async resendEmail() {
      const flag = await this.approveMx(
        `Xác nhận gửi lại mail cho Hợp đồng ${this.dataContract.code}`
      )
      if (flag !== true) return
      try {
        this.showLoading = true
        const response = await ContractService.resendEmail({
          recipient: this.customerInfo.email,
          recipientCC: [],
          sender: 'WEB',
        })
        if (response.code === 1000) {
          this.showSuccessMx(response.message)
        } else {
          this.showFailMx(response.message ?? response.error)
        }
      } catch (error) {
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },
    async updateReqCheck() {
      try {
        this.showLoading = true
        const response = await SalesManagerService.updateReqCheck({
          contractId: this.dataContract.id,
        })
        if (response.code === 1000) {
          this.$router.push({
            path: `/approve-update/${this.dataContract.id}`,
          })
        } else {
          if (response.code === 88080) {
            this.showSuccessMx(response.message)
          } else {
            this.showFailMx(response.message ?? response.error)
          }
        }
      } catch (error) {
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },
    async stateSyncMpos() {
      try {
        this.showLoading = true
        const params = {
          customerId: this.dataContract.customerId,
        }
        const response = await ContractService.checkDetailMposMc(params)
        if (response.code === 1000) {
          await this.getDetailContract(this.$route.params.id)
          this.showSuccessMx(`Đồng bộ thành công.<br>
          Trạng thái MPOS: ${response.message}`)
          this.showLoading = false
        } else {
          console.log('response::::', response)
          this.showFailMx(response.message ?? response.error)
        }
      } catch (error) {
        console.log('error::::::', error)
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },
    async resendOTP(typeAction, unique, option = null) {
      try {
        this.showLoading = true
        const newMobile = this.customerInfo.authoriserContactNumber.replace(/\s+/g, '')
        const params = {
          mobile: newMobile,
          unique,
          typeAction,
        }
        if (option) params.isZns = option
        const response = await ContractService.actionResendOTP(params)
        if (response.code === 1000) {
          if (typeAction === 'RESEND_OTP') this.showSuccessMx(response.message)
          else {
            const { titleVNode, messageVNode } = this.showMsgMx(response.data.contentMessage, true)
            this.$bvModal
              .msgBoxConfirm([messageVNode], {
                title: [titleVNode],
                centered: true,
                okTitle: 'Copy ND',
                cancelTitle: 'Copy SĐT',
              })
              .then(s => {
                if (s === true) this.coppyText(response.data.contentMessage)
                else if (s === false) this.coppyText(newMobile)
              })
          }
        } else {
          this.showFailMx(response.message ?? response.error)
        }
      } catch (error) {
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },
    async coppyText(text) {
      navigator.clipboard.writeText(text)
      this.$nextTick(() => {
        this.showSuccessMx('Copy thành công')
      })
    },
    canReCreateReceipt(state) {
      return (
        [
          'EXPERTISE',
          'APPROVED',
          'PENDING_APPROVAL',
          'PENDING_CONFIRM_APPROVAL',
          'ACTIVE',
          'SIGNED_MISS_IMAGE',
        ].includes(state) && this.canAccessMx('SCON_RECEIPT_RE_CREATE')
      )
    },
    canOnVinvoice(typeCustomer, groupService, customerInfoRes, customerInfoCommon) {
      const accessCondition =
        this.canAccessMx('CNPS_CSTM_OFF_VINVOICE') &&
        ['PAYMENT', 'SELL']?.includes(groupService) &&
        ['COMPANY', 'HOUSEHOLD', 'INDIVIDUAL'].includes(typeCustomer)
      return accessCondition
      // if (customerInfoRes) {
      //   return accessCondition && (!customerInfoRes.enableSendMonthlyReport || customerInfoRes.enableSendMonthlyReport === false);
      // } else if (customerInfoCommon) {
      //   return accessCondition && (!customerInfoCommon.enableSendMonthlyReport || customerInfoCommon.enableSendMonthlyReport === false);
      // }
    },

    canOffVinvoice(typeCustomer, groupService, customerInfoRes, customerInfoCommon) {
      const accessCondition =
        this.canAccessMx('CNPS_CSTM_OFF_VINVOICE') &&
        groupService === 'PAYMENT' &&
        ['COMPANY', 'HOUSEHOLD'].includes(typeCustomer)
      if (customerInfoRes) {
        return accessCondition && customerInfoRes.enableSendMonthlyReport === true
      } else if (customerInfoCommon) {
        return accessCondition && customerInfoCommon.enableSendMonthlyReport === true
      }
    },
    canApproveRejectAppendix(appendixState, contractState, stateCollaborator) {
      return (
        appendixState === 'SIGNED_WAITING_APPROVED' &&
        (['APPROVED', 'PENDING_APPROVAL', 'PENDING_CONFIRM_APPROVAL', 'ACTIVE'].includes(
          contractState
        ) ||
          (contractState === 'EXPERTISE_COLLABORATOR' &&
            ['APPROVED', 'WAITING'].includes(stateCollaborator)) ||
          (contractState === 'LIQUIDATE' && ['SIGNED_WAITING_APPROVED'].includes(appendixState))) &&
        // this.canAccessMx("CNPS_SCON_SA_APPROVED_APPENDIX")
        (this.canAccessMx('CNPS_SCON_SA_APPROVED_APPENDIX') ||
          this.canAccessMx('CNPS_SCON_APPROVE_TINGBOX_CONTRACT'))
      )
    },
    canApproveRejectAppendix_SA(appendixState, typeSale, typeAppendix) {
      if (['HAND_OVER', 'RECALL'].includes(typeAppendix))
        return (
          ['PENDING_APPROVAL', 'APPROVED'].includes(appendixState) &&
          ['SALE_ADMIN', 'SALE_DIRECTOR'].includes(typeSale) &&
          this.canAccessMx('CNPS_SCON_SA_APPROVED_APPENDIX')
        )
      return (
        ['APPROVED', 'PENDING_APPROVAL', 'LIQUIDATE'].includes(appendixState) &&
        // ['SALE_ADMIN', 'SALE_DIRECTOR'].includes(typeSale) &&
        (this.canAccessMx('CNPS_SCON_SA_APPROVED_APPENDIX') ||
          this.canAccessMx('CNPS_SCON_APPROVE_TINGBOX_APPENDIX'))
      )
    },
    canUpdateMerchantKeyToNormal(state, customerInfoCommon, customerInfoRes) {
      const accessCondition =
        this.canAccessMx('CNPS_CSTM_MERCHANT_KEY_UPDATE_MASTER') &&
        [
          'SIGNED_WAITING_APPROVED',
          'APPROVED',
          'ADDITIONAL',
          'ACTIVE',
          'PENDING_APPROVAL',
          'SIGNED_MISS_IMAGE',
          'EXPERTISE',
        ].includes(state)
      if (customerInfoCommon && customerInfoCommon.mcLvl == 'MC_KEY' && accessCondition) {
        return true
      } else if (customerInfoRes && customerInfoRes.mcLvl == 'MC_KEY' && accessCondition) {
        return true
      }
    },
    canUseVietQRFee(typeCustomer, appendixState) {
      if (
        typeCustomer == 'HOUSEHOLD' &&
        [
          'NEW',
          'WAITING_APPROVED_FEE',
          'APPROVED_FEE',
          'SENT',
          'WAITING_SIGN',
          'SIGNING',
          'SIGNED_MISS_IMAGE',
          'SIGNED_WAITING_APPROVED',
        ].includes(appendixState)
      ) {
        // Hộ kinh doanh
        return true
      } else if (
        typeCustomer == 'COMPANY' &&
        ['NEW', 'WAITING_APPROVED_FEE', 'APPROVED_FEE', 'SENT'].includes(appendixState)
      ) {
        // Doanh nghiệp
        return true
      }
      return false
    },
    async updateMerchantKeyToNormal(customerId) {
      try {
        const flag = await this.approveMx(
          'Nhấn xác nhận để chuyển MC từ  MC key về MC thường (và đồng bộ dữ liệu sang MPOS)'
        )
        if (flag !== true) return
        this.showLoading = true
        const params = {
          mcLvl: 'MC_NORMAL',
          customerId,
        }
        const response = await ContractService.updateMerchantKeyToNormal(params)
        if (response.code === 1000) {
          this.getDetailContract()
          this.showSuccessMx(
            'Đã chuyển từ MC key về MC thường thành công (và đồng bộ dữ liệu sang MPOS)'
          )
          return true
        } else {
          this.showFailMx(response.message ?? response.error)
        }
      } catch (error) {
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },
    async updateMerchantKeyToMcKey(customerId) {
      // CHỈ chạy API nếu người dùng ấn "Xác nhận"
      let confirmed = false
      try {
        confirmed = await this.$bvModal.msgBoxConfirm(
          this.$createElement('div', [
            this.$createElement('div', { class: 'form-group' }, [
              this.$createElement('label', 'Loại tài khoản ngân hàng '),
              this.$createElement(
                'select',
                {
                  ref: 'bankAccType',
                  class: 'form-control',
                  domProps: { value: 'MC_COMPANY' },
                },
                [
                  this.$createElement('option', { domProps: { value: 'MC_COMPANY' } }, 'Công ty'),
                  this.$createElement(
                    'option',
                    { domProps: { value: 'MC_INDIVIDUAL' } },
                    'Cá nhân'
                  ),
                ]
              ),
            ]),
            this.$createElement('div', { class: 'form-group' }, [
              this.$createElement('label', 'Thương hiệu'),
              this.$createElement('input', {
                ref: 'brand',
                class: 'form-control',
                attrs: {
                  type: 'text',
                  placeholder: 'Nhập brand',
                  value: this.dataContract?.customerInfoCommon?.brand || '', // default value
                },
              }),
            ]),
            this.$createElement('div', { class: 'form-group' }, [
              this.$createElement('label', 'Sở hữu nhãn hiệu'),
              this.$createElement(
                'select',
                {
                  ref: 'brandOwnerType',
                  class: 'form-control',
                  domProps: { value: 'MC_OWNER' },
                },
                [
                  this.$createElement('option', { domProps: { value: 'MC_OWNER' } }, 'Chính chủ'),
                  this.$createElement(
                    'option',
                    { domProps: { value: 'MC_FRANCHISE' } },
                    'Nhượng quyền'
                  ),
                ]
              ),
            ]),
          ]),
          {
            title: 'Nhập thông tin chuyển thành MC Key',
            okTitle: 'Xác nhận',
            cancelTitle: 'Huỷ',
            centered: true,
            size: 'md',
            // Các option sau giúp phân biệt cách đóng modal (tuỳ nhu cầu):
            // noCloseOnBackdrop: true,
            // noCloseOnEsc: true,
            // hideHeaderClose: true,
          }
        )
      } catch (e) {
        // msgBoxConfirm hiếm khi throw; nếu có lỗi thật, mới hiện thông báo
        this.showFailMx(e?.message || e)
        return
      }

      // Người dùng bấm "Huỷ" hoặc đóng modal -> KHÔNG gọi API
      if (!confirmed) return

      // --------- Chỉ chạy tiếp khi đã Confirm ---------
      try {
        // Lấy giá trị từ modal
        const bankAccType = this.$refs.bankAccType?.value
        const brand = this.$refs.brand?.value
        const brandOwnerType = this.$refs.brandOwnerType?.value

        if (!bankAccType || !brand || !brandOwnerType) {
          this.showFailMx('Vui lòng nhập đầy đủ thông tin bắt buộc!')
          return
        }

        this.showLoading = true
        const params = {
          mcLvl: 'MC_KEY',
          customerId,
          bankAccType,
          brand,
          brandOwnerType,
        }

        const response = await ContractService.updateMerchantKeyToNormal(params)
        if (response.code === 1000) {
          this.getDetailContract()
          this.showSuccessMx('Đã chuyển thành MC key thành công (và đồng bộ dữ liệu sang MPOS)')
          return true
        } else {
          this.showFailMx(response.message ?? response.error)
        }
      } catch (error) {
        this.showFailMx(error?.message || error)
      } finally {
        this.showLoading = false
      }
    },
    showModalTextMerchantKeyOnus(message, title = 'Lưu ý') {
      const h = this.$createElement
      const messageVNode = h('p', { class: 'f14' }, message)
      return this.$bvModal.msgBoxConfirm([messageVNode], {
        title: title,
        okTitle: 'Tiếp tục',
        cancelTitle: 'Huỷ',
        centered: true,
      })
    },
    showModalNoteMerchantKeyOnus(message = '', title = 'Lý do từ chối', value = '') {
      const h = this.$createElement
      const messageVNode = h('div', { class: 'form-group pos-relative' }, [
        h('p', { class: 'f14' }, message),
        h('textarea', { ref: 'rejectValue', class: 'form-control f12', domProps: { value } }),
      ])
      return this.$bvModal
        .msgBoxConfirm([messageVNode], {
          id: 'rejectMx',
          title: title,
          okTitle: 'Tiếp tục',
          cancelTitle: 'Huỷ',
          centered: true,
          okDisabled: false,
        })
        .then(async value => {
          return {
            value,
            note: this.$refs.rejectValue.value,
          }
        })
    },
    async addVietQrFee(appendixId, templateFee) {
      const flag = await this.approveMx('Nhấn Xác nhận để thêm điều khoản!')
      if (flag !== true) return
      try {
        this.showLoading = true
        const res = await ContractService.addVietQrFee({
          appendixId,
          templateFee,
        })
        if (res.code === 1000) {
          this.getDetailContract()
          this.showSuccessMx('Thêm điều khoản thành công')
        } else {
          this.showFailMx(res.message ?? res.error)
        }
      } catch (error) {
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },
    async removeVietQrFee(appendixId, templateFee) {
      const flag = await this.approveMx('Nhấn Xác nhận để xóa điều khoản!')
      if (flag !== true) return
      try {
        this.showLoading = true

        const res = await ContractService.removeVietQrFee({
          appendixId,
          templateFee,
        })
        if (res.code === 1000) {
          this.getDetailContract()
          this.showSuccessMx('Xóa điều khoản thành công')
        } else {
          this.showFailMx(res.message ?? res.error)
        }
      } catch (error) {
        this.showFailMx(error)
      } finally {
        this.showLoading = false
      }
    },
    checkRequestApproveNewBranch(appendix) {
      let message = ''
      const merchantBusinessAreas =
        appendix.merchantBusinessAreas && appendix.merchantBusinessAreas.length > 0
          ? appendix.merchantBusinessAreas
          : []
      if (merchantBusinessAreas.length > 0) {
        const data = []
        for (let i = 0; i < merchantBusinessAreas.length; i++) {
          if (
            merchantBusinessAreas[i].isChoose &&
            merchantBusinessAreas[i].isChoose === true &&
            merchantBusinessAreas[i].isNew &&
            merchantBusinessAreas[i].isNew === true
          ) {
            data.push(merchantBusinessAreas[i].id)
          }
        }
        message += `Bạn đang có ${data.length} phiếu thẩm định chi nhánh mới cho phụ lục này. Hãy xử lý phiếu nhé`
      }
      return message
    },
    handleOpenDKKD() {
      this.$refs['modal-dkkd']?.show()
    },
    handleOpenTPV() {
      this.$refs['modal-tpv']?.show()
    },
    async handleUpdateContract(params) {
      try {
        this.showLoading = true
        const res = await updateMcContract({
          ...params,
          contractId: this.dataContract.id,
        })

        if (res.code === 1000) {
          this.showSuccessMx(res.message)
        } else {
          this.showFailMx(res.message ?? res.error)
        }
        this.$refs['modal-dkkd']?.hide()
        this.$refs['modal-tpv']?.hide()
        this.showLoading = false
      } catch (e) {
        this.showLoading = false
        this.showFailMx(e.response?.data?.message ? e.response.data.message : e.message)
      }
    },
  },
}
